import { framedByDefault } from '@utils/frames';
import { consolidateFrames } from '@utils/product';
import { shopifyAdminIdToGraphqlId } from '@utils/shopifyIds';

import { FramingProduct } from '../../../components/Checkout/Framing/types';
import { ProductContextEntry } from '../../../providers/ProductProvider';
import { CheckoutWork } from './workView';

type BuildFramingProductsArgs = {
  getEntry: (shopifyId: string) => ProductContextEntry | null;
  selectedWorks: CheckoutWork[];
};

export const buildFramingProducts = ({
  getEntry,
  selectedWorks,
}: BuildFramingProductsArgs): FramingProduct[] =>
  selectedWorks.flatMap((work) => {
    const purchaseDetails = getEntry(work.id)?.shopifyPurchaseDetails;
    if (!purchaseDetails?.frames?.length) return [];

    const graphqlProductId = shopifyAdminIdToGraphqlId(work.id);
    const quantity = work.quantity ?? 1;

    const frameOptions = consolidateFrames({
      compositeImageProductShopifyId: graphqlProductId,
      frameOptions: purchaseDetails.frames,
      frameRecommendedLabel: purchaseDetails.frameRecommendedLabel ?? null,
      frameRecommendedTitle: purchaseDetails.frameRecommendedTitle ?? null,
      selection: [{ id: graphqlProductId, quantity }],
    });

    if (!frameOptions.length) return [];

    return [
      {
        framedByDefault: framedByDefault(purchaseDetails.framingOffered),
        frameOptions,
        id: work.id,
        subtotal: work.price * quantity,
        thumbnailAlt: work.imageAlt,
        thumbnailSrc: work.imageSrc,
        title: work.title,
      },
    ];
  });
